import AVdxbProgressStep from './index.vue';

AVdxbProgressStep.install = app => {
  app.component(AVdxbProgressStep.name, AVdxbProgressStep);
};

export default AVdxbProgressStep;
